import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getNewFilterdProducts } from "../../store/actions/product-actions";
import { SET_FILTER } from "../../store/types";

const ShopBrand = ({ tags, models, getSortParams }) => {
  const dispatch = useDispatch();
  const currentFilters = useSelector((state) => state.products.filter);

  const handleBrandClick = (brandId) => {
    let newBrands = [...(currentFilters.brands || [])];

    if (newBrands.includes(brandId)) {
      newBrands = newBrands.filter(id => id !== brandId);
    } else {
      newBrands.push(brandId);
    }

    dispatch({
      type: SET_FILTER,
      payload: { filterType: "brands", value: newBrands },
    });

    // Clear model selection when brands change
    dispatch({
      type: SET_FILTER,
      payload: { filterType: "modelId", value: "" }, // Keep this as a string
    });

    dispatch(
      getNewFilterdProducts({
        ...currentFilters,
        page: 1,
        limit: 15,
        brands: newBrands,
        modelId: "", // Reset to empty string
      })
    );
  };

  // const handleModelClick = (modelId) => {
  //   let selectedModels = currentFilters.modelId ? currentFilters.modelId.split(',') : [];

  //   if (selectedModels.includes(modelId)) {
  //     selectedModels = selectedModels.filter(id => id !== modelId);
  //   } else {
  //     selectedModels.push(modelId);
  //   }

  //   const newModelId = selectedModels.join(','); // Convert back to a string

  //   dispatch({
  //     type: SET_FILTER,
  //     payload: { filterType: "modelId", value: newModelId }, // Dispatch the comma-separated string
  //   });

  //   dispatch(
  //     getNewFilterdProducts({
  //       ...currentFilters,
  //       page: 1,
  //       limit: 15,
  //       modelId: newModelId, // Use the comma-separated string
  //     })
  //   );

  //   getSortParams("modelId", newModelId);
  // };

  const handleModelClick = (modelId) => {
    if (modelId === '') {
      // Clear model selection when "All Models" is clicked
      dispatch({
        type: SET_FILTER,
        payload: { filterType: "modelId", value: "" }, // Reset to empty string
      });

      dispatch(
        getNewFilterdProducts({
          ...currentFilters,
          page: 1,
          limit: 15,
          modelId: "", // Reset to empty string
        })
      );

      getSortParams("modelId", ""); // Pass empty string
    } else {
      // Handle single model selection
      let selectedModels = currentFilters.modelId ? currentFilters.modelId.split(',') : [];

      if (selectedModels.includes(modelId)) {
        selectedModels = selectedModels.filter(id => id !== modelId);
      } else {
        selectedModels.push(modelId);
      }

      const newModelId = selectedModels.join(',');

      dispatch({
        type: SET_FILTER,
        payload: { filterType: "modelId", value: newModelId },
      });

      dispatch(
        getNewFilterdProducts({
          ...currentFilters,
          page: 1,
          limit: 15,
          modelId: newModelId,
        })
      );

      getSortParams("modelId", newModelId);
    }
  };


  // Show models if any brand is selected
  const filteredModels = currentFilters.brands?.length > 0
    ? models.filter((model) => currentFilters.brands.includes(model.brandId))
    : [];

  return (
    <>
      <div style={{
        padding: "24px",
        border: "1px solid #e2e8f0",
        borderRadius: "8px",
        backgroundColor: "white",
        marginTop: "50px"
      }}>
        {/* Brands Section */}
        <h4 style={{
          fontSize: "16px",
          fontWeight: "600",
          color: "#2d3748",
          marginBottom: "16px",
          paddingBottom: "8px",
          borderBottom: "1px solid #edf2f7"
        }}>Brand</h4>

        <div style={{ marginTop: "20px" }}>
          {tags ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ display: "flex", alignItems: "center", cursor: "pointer", padding: "6px 0" }}>
                <input
                  type="checkbox"
                  checked={currentFilters.brands?.length === 0}
                  onChange={() => {
                    dispatch({
                      type: SET_FILTER,
                      payload: { filterType: "brands", value: [] },
                    });
                    dispatch(
                      getNewFilterdProducts({
                        ...currentFilters,
                        brands: [],
                        modelId: "",
                      })
                    );
                  }}
                  style={{
                    width: "16px",
                    height: "16px",
                    accentColor: "#4299e1",
                    marginRight: "8px"
                  }}
                />
                <span style={{ color: currentFilters.brands?.length === 0 ? "#4299e1" : "#4a5568" }}>
                  All Brands
                </span>
              </label>

              {tags.map((brand) => (
                <label
                  key={brand._id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "6px 0"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={currentFilters?.brands?.includes(brand._id)}
                    onChange={() => handleBrandClick(brand._id)}
                    style={{
                      width: "16px",
                      height: "16px",
                      accentColor: "#4299e1",
                      marginRight: "8px"
                    }}
                  />
                  <span style={{ color: currentFilters?.brands?.includes(brand._id) ? "#4299e1" : "#4a5568" }}>
                    {brand.name}
                  </span>
                </label>
              ))}
            </div>
          ) : (
            <div style={{ color: "#718096" }}>No brands found</div>
          )}
        </div>

        {/* Models Section - Only shows when brands are selected */}
        {currentFilters.brands?.length > 0 && (
          <div style={{ marginTop: "40px" }}>
            <h4 style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "16px",
              paddingBottom: "8px",
              borderBottom: "1px solid #edf2f7"
            }}>Models</h4>

            <div style={{ marginTop: "20px" }}>
              {filteredModels.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer", padding: "6px 0" }}>
                    <input
                      type="radio"
                      name="model"
                      checked={currentFilters.modelId === ''}
                      onChange={() => handleModelClick('')}
                      style={{
                        width: "16px",
                        height: "16px",
                        accentColor: "#4299e1",
                        marginRight: "8px"
                      }}
                    />
                    <span style={{ color: currentFilters.modelId === '' ? "#4299e1" : "#4a5568" }}>
                      All Models
                    </span>
                  </label>

                  {filteredModels.map((model) => (
                    <label
                      key={model._id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "6px 0"
                      }}
                    >
                      <input
                        type="radio"
                        name="model"
                        checked={currentFilters.modelId.includes(model._id)}
                        onChange={() => handleModelClick(model._id)}
                        style={{
                          width: "16px",
                          height: "16px",
                          accentColor: "#4299e1",
                          marginRight: "8px"
                        }}
                      />
                      <span style={{ color: currentFilters.modelId.includes(model._id) ? "#4299e1" : "#4a5568" }}>
                        {model.name}
                      </span>
                    </label>
                  ))}
                </div>
              ) : (
                <div style={{ color: "#718096" }}>No models found for the selected brands</div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

ShopBrand.propTypes = {
  tags: PropTypes.array.isRequired,
  models: PropTypes.array.isRequired,
  getSortParams: PropTypes.func.isRequired,
};

export default ShopBrand;